import { TotLocale } from '../types';

export const ru = TotLocale.ru;
export const en = TotLocale.en;

export const defaultLocale = ru;
export const defaultFormsLocale = ru;

export const supportedLocales: TotLocale[] = [ru, en];
